module.exports = __webpack_public_path__ + "static/features-accessibility-audit-9ca6b5ded9cd0a3930bd50c74fcb59f0.jpg";